import React from "react";
import { LandingPageData } from "./LandingPage.js";

export default class LandingPage extends React.Component {
  state = {
    Data: LandingPageData,
  };

  render() {
    let response = this.state.Data.map((obj, index) => {
      return (
        <div className="landing-page-text" key={index}>
          <h1>
            {obj.h1} <br /> {obj.h2}
          </h1>
          <p>
            Website coming soon<br/>
          </p>
          {/* <button className="g-btn"> {obj.BtnText} </button> */}
        </div>
      );
    });
    return <section> {response} </section>;
  }
}
